'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'space-station-moon';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e033';
var svgPathData = ['M0 256c0 10.8 .7 21.4 2 31.9 72.4 25.2 159.6 40.1 254 40.1s181.6-14.9 254-40.1c1.3-10.5 2-21.1 2-31.9 0-141.4-114.6-256-256-256S0 114.6 0 256zm15 86.5C50.5 441.3 145 512 256 512s205.5-70.7 241-169.5C425.2 364 343 376 256 376S86.8 364 15 342.5zM272 160a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z', 'M160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM256 328c-94.4 0-181.6-14.9-254-40.1 2.4 18.9 6.8 37.2 13 54.6 71.8 21.4 154 33.5 241 33.5s169.2-12 241-33.5c6.3-17.4 10.7-35.7 13-54.6-72.4 25.2-159.6 40.1-254 40.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSpaceStationMoon = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;